import { useSetPageTitle } from "src/hooks/useSetPageTitle";
import { AppLayout } from "src/components/layout/app-layout";
import ReportsTab from "./tabs/reports.tab";
import InsightsTab from "./tabs/insights.tab";
import { useNavigate, useParams } from "react-router-dom";


const ReportsPage = () => {
  useSetPageTitle('Reports');
  const navigate = useNavigate();
  const { clientId } = useParams<{ clientId?: string }>();

  const reportsTabs = [
    {
      id: '',
      key: 'ALL',
      label: 'Reports',
    },
    // {
    //   id: 'insights',
    //   label: 'Insights',
    // },
  ];

  const { tab } = useParams<{ tab?: string }>();

  const validTabs = reportsTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const handleTabChange = (tabId: string) => {
    if (clientId) {
      navigate(`/client/${clientId}/reports/${tabId}`);
    } else {
      navigate(`/reports/${tabId}`);
    }
  };

  return (
    <AppLayout
      activePage="/client/reports"
      navbarProps={{
        showBackButton: false,
        backPath: clientId ? `/client/${clientId}/reports` : '/reports',
        tabs: reportsTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="h-[calc(100vh-8rem)]">
        {currentTab === '' && <ReportsTab showOldVersionButton={true} />}
        {currentTab === 'insights' && <InsightsTab />}
      </div>
    </AppLayout>
  );
};

export default ReportsPage;